import React from 'react';
import styled from 'styled-components';

const IconContainer = styled.div`
  display: inline-block;
  font-size: 20px;
  padding: 0 5px 0 0;
  position: relative;
`;

export default IconContainer;
